<template>
  <div>
    <div v-if="!stepSelectBranch">
      <main-header>
        <data-form
          :title="title"
          :sub_title="`${$t('otp.input-confirm-otp',{number: phoneNumber})}`"
          show_logo
        >
          <div class="flex crm-otp-entry">
            <div
              :class="`otp-input-box ${isError ? 'otp-input-box_error' : ''}`"
              v-for="dot in [0, 1, 2, 3, 4, 5]"
              :key="'dot-' + dot"
            >
              <div
                class="dot"
                v-if="OTPValidateForm.numberOTP.length >= dot + 1"
              >{{OTPValidateForm.numberOTP[dot]}}</div>
              <div
                class="crm-otp-cursor"
                v-if="OTPValidateForm.numberOTP.length == dot"
              >
                |
              </div>
            </div>
            <input
              id="hide-input"
              v-model="OTPValidateForm.numberOTP"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              @input="authOTPCode()"
              @keypress="onlyNumber"
              @focus="trackAuthentication(19)"
              autocomplete="off"
              maxlength="6"
              ref="otp_input"
            />
          </div>
          <el-row>
            <el-col v-if="isError && !isCountDown" class="error-msg">
              <p>
                {{ isError }} <br>
                <span>{{ $t('otp.not-received-otp') }}</span>
                <a class="crm-resend-code" type="primary" @click="handleResendOTP">{{ $t('otp.send-again') }}</a>
              </p>
            </el-col>
            <el-col v-else-if="isError" class="error-msg">
              <p >
                {{ isError }} <br>
                <a type="primary">{{ $t('otp.send-again-in') }} {{ countdown }}</a>
              </p>
            </el-col>
            <el-col v-else-if="!isCountDown" class="crm-resend-code">
              <span class="crm-unsend-code">{{ $t('otp.not-received-otp') }}</span>
              <a type="primary" @click="handleResendOTP">{{ $t('otp.send-again') }}</a>
            </el-col>
            <el-col v-else class="crm-resend-code crm-unsend-code">
              <a type="primary">{{ $t('otp.send-again-in') }} {{ countdown }}</a>
            </el-col>
          </el-row>
          <el-divider class="mt-4 mb-2">{{ $t('login.or') }}</el-divider>
          <el-row>
            <el-col style="text-align: center;">
              <el-button
                class="btn-change-phone"
                @click="backToLogin"
              >
                <span>
                  <svgRefresh/>{{ $t('otp.change-phone') }} 
                </span>
              </el-button>
            </el-col>
          </el-row>
        </data-form>
      </main-header>
    </div>
    <!-- linktree ขึ้นตอนไม่มีสาขา และอยู่ในสเต็ปการเลือกสาขา -->
    <link-tree v-else-if="!haveBranch && stepSelectBranch" :stepSelectBranch="stepSelectBranch" @redirectFunction="redirectFunction"></link-tree>
  </div>
</template>

<script>
const moment = require("moment");
import mixins from "../../helper/mixins";
import { mapActions, mapGetters, mapMutations } from "vuex";
import DataForm from "@/components/DataForm";
import MainHeader from "@/components/MainHeader.vue";
const svgRefresh = () => import("@/assets/svg/refresh.svg");
import GATracking from "@/helper/GATrackingMixins";
import linkTree from '@components/elements/linktree.vue';
import TokenStorage from '@/store/storage/token.storage'

export default {
  components: {
    DataForm,
    MainHeader,
    svgRefresh,
    linkTree
  },
  mixins: [mixins, GATracking],
  data() {
    return {
      title: this.$t('otp.input-otp'),
      numberOTP: null,
      OTPValidateForm: { numberOTP: "" },
      isCountDown: false,
      countdown: "...",
      timerOtp: false,
      isLoading: false,
      isError: false,
      haveBranch : false,
      stepSelectBranch : false,
      fullscreenLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      restaurantInfo: "restaurant/restaurantInfo",
      branchInfo: "branch/branchInfo",
      authDialog: "auth/authDialog",
      otpTime: "auth/otpTime",
      branchUUID : "branch/branchUUID",
      refCodeOTP : "auth/refCodeOtp",
      lineToken: "auth/lineToken"
    }),
    phoneNumber() {
      return this.getFormatPhoneNumber(this.$route.query.PhoneNumberRef1);
    },
  },
  async mounted() {
    this.haveBranch = (this.branchUUID != null) && (this.branchUUID != 'null') ? true : false
    this.$refs.otp_input.focus();
    this.setCountDown();
  },
  methods: {
    ...mapActions({
      verifyPhoneNumber: "auth/verifyPhoneNumber",
      verifyCodeOTP: "auth/verifyCodeOTP",
      login : "auth/login",
    }),
    ...mapMutations({
      setOtpTime: "auth/SET_OTP_TIME",
      clearOtpTime: "auth/CLEAR_OTP_TIME",
      setRefCode: "auth/SET_REF_CODE_OTP"
    }),
    backToLogin(){
      this.$router.push({ name: "Login" });
    },
    async authOTPCode() {
      this.isError = false;
      if (this.OTPValidateForm.numberOTP.length == 6) {
        this.isLoading = this.$loading({
          lock: true,
        });
        this.verifyCodeOTP({
          phoneNumber: this.$route.query.PhoneNumberRef2,
          otp: this.OTPValidateForm.numberOTP.toString(),
          refCode: this.$route.query.refCode,
          phoneCountryCode: this.$route.query.countryCode,
          restaurantUUID: this.restaurantInfo.restaurantUUID,
          recaptchaToken: TokenStorage.recaptchaToken,
          lineAccessToken: this.lineToken? this.lineToken : null
        }).then((res) => {
          this.checkBranchLink()
        }).catch((error) => {
          this.OTPValidateForm.numberOTP = "";
          if(error.response.status == 401)
            this.isError =  this.$t('store.auth.invalid-otp')
          else
            this.isError = error.message;
        })
        .finally(() => {
          this.isLoading.close();
        });
      }
    },
    async handleResendOTP() {
      this.isError = false;
      this.setCountDown();
      // PhoneNumberRef1: มีการเติม +66 ข้างหน้า เช่น +6688888888
      // PhoneNumberRef2: คือเบอร์ปกติที่ไม่มี +66 จะเป็น 0 แทน เช่น 088888888
      this.isLoading = true;
      this.verifyPhoneNumber({
        recaptchaToken: TokenStorage.recaptchaToken,
        restaurantAlias: this.restaurantInfo.restaurantUUID,
        PhoneNumberRef1: this.$route.query.PhoneNumberRef1,
        PhoneNumberRef2: this.$route.query.PhoneNumberRef2,
        countryCode: this.$route.query.countryCode,
      })
        .catch((error) => {
          this.OTPValidateForm.numberOTP = "";
          this.isError = error.message;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    setCountDown() {
      this.isCountDown = true;
      if (this.timerOtp) clearInterval(this.timerOtp);

      const nowTime = new Date().getTime();
      const duration = 60 * 2000; // 2 min
      let endTime = nowTime + duration; // in timestamp
      if (this.otpTime && nowTime > this.otpTime) {
        endTime = new Date(this.otpTime + duration);
      } else {
        this.setOtpTime(nowTime);
      }

      this.countdown = moment(new Date(endTime - new Date().getTime())).format(
        "mm:ss"
      );
      this.timerOtp = setInterval(() => {
        this.countdown = moment(
          new Date(endTime - new Date().getTime())
        ).format("mm:ss");
      }, 1000); // 1 sec

      setTimeout(() => {
        this.isCountDown = false;
        clearInterval(this.timerOtp);
        this.clearOtpTime();
      }, endTime - new Date().getTime());
    },
    checkBranchLink(){
      //ถ้าไม่ม่สาขาต้องเข้าเลือกสาขาก่อน
      if(!this.haveBranch && !this.stepSelectBranch){
        this.stepSelectBranch = true
      }
      else
        this.login()
    },
    redirectFunction(){
      this.fullscreenLoading = true
      this.login()
    },
  },
};
</script>

<style scoped>

.d-flex-center-middle {
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #000000;
  }
}

@-webkit-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #000000;
  }
}

.white-box {
  height: 70vh;
}

.otp-input-box {
  max-width: 44px;
  width: 44px;
  width: -webkit-fill-available;
  height: 50px;
  position: relative;
  background: #f9f9f9;
  border-radius: 8px;
  margin-left: 8px;
  border: 1px solid #cfd0d1;
}
.otp-input-box_error {
  border-color: var(--error);
}

.back-input-phone {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-decoration-line: underline;
  color: #28B7FF;
  text-decoration-thickness: 0.5px;
  text-underline-offset: 2px;
  margin-left: 5px;
  width: 100px;
}
.btn-change-phone{
  margin-top: 24px;
  width: 100%;
  color: #28B7FF;
  border: 1px solid #28B7FF;
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}
.btn-change-phone span{
  display: flex;
  align-items: center;
}
.mt-15-flex-center {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.dot {
  display: inline-block;
  position: absolute;
  top: 20%;
  left: 40%;
  font-size: 24px;
}

.crm-otp-entry {
  width: 100%;
  margin: auto;
  margin-top: 32px;
  margin-bottom: 0;
  justify-content: center;
}

.crm-otp-cursor {
  top: 10%;
  position: relative;
  margin: 0;
  font-weight: 200;
  font-size: 30px;
  color: #000000;
  display: block;
  text-align: center;
  -webkit-animation: 1s blink step-end infinite;
  -moz-animation: 1s blink step-end infinite;
  -ms-animation: 1s blink step-end infinite;
  -o-animation: 1s blink step-end infinite;
  animation: 1s blink step-end infinite;
}

#hide-input {
  background: transparent;
  border: none;
  outline: none;
  color: transparent;
  position: absolute;
  width: 80%;
  height: 50px;
  font-size: 1px;
  overflow: hidden;
}

.crm-resend-code {
  margin-top: 24px;
  text-align: center;
  color: var(--primary);
  font-size: 20px;
}

.crm-unsend-code {
  color: #999999;
}

.error-msg {
  /* height: 65px; */
  margin-top: 24px;
  /* margin-bottom: 32px; */
}
.error-msg p {
  margin: 0;
  text-align: center;
  color: var(--error);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
}
.el-divider__text {
  color: #BDBDBD;
}
</style>